import RequestService from "@/configurations/AxiosConfig";

const controller = 'upload'; 

const endpoints = {
  profilePhoto: `${controller}/profilePhoto`,
};

const UploadService = {
  profilePhoto: (data: FormData) => RequestService.post(endpoints.profilePhoto, data)
};

export default UploadService;
